/**
 * Most Popular Vue component
 * ------------------------------------------------------------------------------
 * Main template in sections/product__related.liquid
 *
 * Recommended products retrieved via Product Recommendations Ajax API
 * https://shopify.dev/docs/themes/ajax-api/reference/product-recommendations
 *
 * Example usage:
 * <most-popular-products inline-template collection-id="{{ product.id }}"/>
 */

import axios from 'axios'
import Cookies from 'js-cookie'

import KeenSlider from '@/js/components/keen-slider.vue'
import ProductItem from '@/js/components/product-item.js'

import { storefrontRequestConfig, STOREFRONT_URL } from '@/js/utils/api'
import { productQuery, transformGraphqlProduct } from '@/js/utils/data'

export default {
  components: {
    KeenSlider,
    ProductItem
  },

  props: {
    collectionHandle: {
      type: String,
      required: true
    },
    productsToShow: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      isLoading: true,
      filteredProducts: [],
      sliderOptions: {
        loop: true,
        slides: {
          perView: 1.055,
          spacing: 8
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 1.0505,
              spacing: 16
            }
          },
          '(min-width: 1280px)': {
            slides: {
              perView: 3.07,
              spacing: 16
            }
          }
        }
      }
    }
  },

  computed: {
    currentState () {
      return Cookies.get('state') || 'NSW' // used to filter products based on the available inventory in a location
    }
  },

  async created () {
    this.filteredProducts = await this._getMostPopularProducts()
    this.isLoading = false
  },

  methods: {
    async _getMostPopularProducts () {
      const data = `{
        collection(handle: "${this.collectionHandle}") {
          products (first: 100, sortKey: BEST_SELLING) {
            edges {
              node {
                ${productQuery}
              }
            }
          }
        }
      }`

      return await axios.post(STOREFRONT_URL, data, storefrontRequestConfig).then(({ data }) => {
        const products = data.data.collection.products.edges
        const filteredProducts = []
        products.forEach((product) => {
          let productItem = {}
          productItem = transformGraphqlProduct(product.node)

          // check if the current state value is ACT
          if (this.currentState === 'ACT') {
            // If the state is ACT, include products from both ACT and NSW warehouses
            if ((productItem.available_on?.includes(this.currentState) || productItem.available_on?.includes('NSW')) && filteredProducts?.length < this.productsToShow) {
              // set the formatted product
              filteredProducts.push(productItem)
            }
          } else {
            // check the state value (from the Cookie) and match if the selected state has an available inventory in the product
            if (productItem.available_on?.includes(this.currentState) && filteredProducts?.length < this.productsToShow) {
              // set the formatted product
              filteredProducts.push(productItem)
            }
          }
        })
        return filteredProducts
      }).catch((error) => {
        console.log('Get products from most popular collection error:', error)
        throw error
      })
    }
  }
}
